"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _EngagementStatusTypes = require("./EngagementStatusTypes");

var _EngagementTypes = require("./EngagementTypes");

var _immutable = require("immutable");

var _PropertyGroupRecord = _interopRequireDefault(require("../property/PropertyGroupRecord"));

var _PropertyOptionRecord = _interopRequireDefault(require("../property/PropertyOptionRecord"));

var _PropertyRecord = _interopRequireDefault(require("../property/PropertyRecord"));

var _PropertyTypes = require("../property/PropertyTypes");

var _taskPriorities = require("./taskPriorities");

var properties = (0, _immutable.Map)({
  'metadata.subject': (0, _PropertyRecord.default)({
    hubspotDefined: true,
    name: 'metadata.subject',
    label: 'Title'
  }),
  'metadata.taskType': (0, _PropertyRecord.default)({
    hubspotDefined: true,
    name: 'metadata.taskType',
    label: 'Task type',
    type: _PropertyTypes.ENUMERATION,
    options: _immutable.List.of((0, _PropertyOptionRecord.default)({
      displayOrder: 0,
      hubspotDefined: true,
      label: 'Call',
      value: _EngagementTypes.CALL
    }), (0, _PropertyOptionRecord.default)({
      displayOrder: 1,
      hubspotDefined: true,
      label: 'Email',
      value: _EngagementTypes.EMAIL
    }))
  }),
  'metadata.priority': (0, _PropertyRecord.default)({
    hubspotDefined: true,
    name: 'metadata.priority',
    label: 'Priority',
    type: _PropertyTypes.ENUMERATION,
    options: _immutable.List.of((0, _PropertyOptionRecord.default)({
      displayOrder: 0,
      hubspotDefined: true,
      label: 'High',
      value: _taskPriorities.HIGH
    }), (0, _PropertyOptionRecord.default)({
      displayOrder: 1,
      hubspotDefined: true,
      label: 'None',
      value: _taskPriorities.NONE
    }))
  }),
  'engagement.timestamp': (0, _PropertyRecord.default)({
    hubspotDefined: true,
    name: 'engagement.timestamp',
    label: 'Due date',
    type: _PropertyTypes.DATE_TIME
  }),
  'metadata.reminders': (0, _PropertyRecord.default)({
    hubspotDefined: true,
    name: 'metadata.reminders',
    label: 'Reminder',
    type: _PropertyTypes.DATE_TIME
  }),
  'engagement.ownerId': (0, _PropertyRecord.default)({
    hubspotDefined: true,
    name: 'engagement.ownerId',
    label: 'Assigned to',
    type: _PropertyTypes.ENUMERATION
  }),
  'engagement.createdBy': (0, _PropertyRecord.default)({
    hubspotDefined: true,
    name: 'engagement.createdBy',
    label: 'Created by',
    type: _PropertyTypes.ENUMERATION,
    hidden: true
  }),
  relatesTo: (0, _PropertyRecord.default)({
    hubspotDefined: true,
    name: 'relatesTo',
    label: 'Associated with',
    type: _PropertyTypes.ENUMERATION
  }),
  'engagement.type': (0, _PropertyRecord.default)({
    hubspotDefined: true,
    name: 'engagement.type',
    label: 'Type',
    type: _PropertyTypes.ENUMERATION,
    hidden: true,
    options: _immutable.List.of((0, _PropertyOptionRecord.default)({
      displayOrder: 0,
      hubspotDefined: true,
      label: 'Email',
      readOnly: true,
      value: _EngagementTypes.EMAIL
    }), (0, _PropertyOptionRecord.default)({
      displayOrder: 1,
      hubspotDefined: true,
      label: 'Call',
      readOnly: true,
      value: _EngagementTypes.CALL
    }), (0, _PropertyOptionRecord.default)({
      displayOrder: 2,
      hubspotDefined: true,
      label: 'Meeting',
      readOnly: true,
      value: _EngagementTypes.MEETING
    }), (0, _PropertyOptionRecord.default)({
      displayOrder: 3,
      hubspotDefined: true,
      label: 'Task',
      readOnly: true,
      value: _EngagementTypes.TASK
    }), (0, _PropertyOptionRecord.default)({
      displayOrder: 4,
      hubspotDefined: true,
      label: 'Note',
      readOnly: true,
      value: _EngagementTypes.NOTE
    }))
  }),
  'metadata.body': (0, _PropertyRecord.default)({
    hubspotDefined: true,
    name: 'metadata.body',
    label: 'Description',
    filterName: 'task.body',
    hidden: true
  }),
  'metadata.status': (0, _PropertyRecord.default)({
    hubspotDefined: true,
    name: 'metadata.status',
    label: 'Status',
    filterName: 'task.status',
    type: _PropertyTypes.ENUMERATION,
    options: _immutable.List.of((0, _PropertyOptionRecord.default)({
      displayOrder: 0,
      hubspotDefined: true,
      label: 'Not started',
      readOnly: true,
      value: _EngagementStatusTypes.NOT_STARTED
    }), (0, _PropertyOptionRecord.default)({
      displayOrder: 1,
      hubspotDefined: true,
      label: 'In progress',
      readOnly: true,
      value: _EngagementStatusTypes.IN_PROGRESS
    }), (0, _PropertyOptionRecord.default)({
      displayOrder: 2,
      hubspotDefined: true,
      label: 'Waiting',
      readOnly: true,
      value: _EngagementStatusTypes.WAITING
    }), (0, _PropertyOptionRecord.default)({
      displayOrder: 3,
      hubspotDefined: true,
      label: 'Completed',
      readOnly: true,
      value: _EngagementStatusTypes.COMPLETED
    }), (0, _PropertyOptionRecord.default)({
      displayOrder: 4,
      hubspotDefined: true,
      label: 'Deferred',
      readOnly: true,
      value: _EngagementStatusTypes.DEFERRED
    }))
  })
});

var _default = (0, _immutable.Map)({
  groups: (0, _immutable.Map)({
    notes: (0, _PropertyGroupRecord.default)({
      displayName: 'Tasks',
      displayOrder: 0,
      hubspotDefined: true,
      name: 'notes',
      properties: properties.keySeq().toList()
    })
  }),
  properties: properties
});

exports.default = _default;
module.exports = exports.default;